export default "__VITE_ASSET__CVefKJxO__"